// extracted by mini-css-extract-plugin
export default {"templateThumbnail":"TemplateThumbnail_templateThumbnail__7fPHE","active":"TemplateThumbnail_active__-EPct","checkIcon":"TemplateThumbnail_checkIcon__ojSyH"};